import { useState } from "react";

const contactChannels = [
  { icon: "ri-mail-line", label: "投稿与合作", value: "hello@pipimiao.example.com" },
  { icon: "ri-message-3-line", label: "作品推荐", value: "推荐你心中的治愈佳作给我们" },
  { icon: "ri-time-line", label: "回复时间", value: "工作日内 24 小时内回复" },
];

export default function Contact() {
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">(
    "idle"
  );
  const [message, setMessage] = useState("");

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new FormData(form);

    const honeypot = String(data.get("website_alt") || "").trim();
    if (honeypot) {
      setStatus("success");
      form.reset();
      return;
    }

    const payload = new URLSearchParams();
    const fields = ["name", "email", "message"];
    for (const field of fields) {
      const value = String(data.get(field) || "").trim();
      if (value) payload.append(field, value);
    }

    setStatus("loading");
    try {
      const res = await fetch(
        "https://readdy.ai/api/form/da23ag3k8r5te5mqsfeg",
        {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          body: payload.toString(),
        }
      );
      const responseText = await res.text();
      let parsed: {
        code?: string;
        message?: string;
        meta?: { message?: string; detail?: string };
      } = {};
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = {};
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || "";
      const isSpam =
        /spam|form data is spam/i.test(
          responseText + " " + serverMsg
        );
      if (res.ok && parsed?.code === "OK" && !isSpam) {
        setStatus("success");
        form.reset();
        setMessage("");
      } else {
        setStatus("error");
        setMessage(serverMsg || "提交失败，请稍后再试。");
      }
    } catch {
      setStatus("error");
      setMessage("网络异常，请稍后再试。");
    }
  };

  return (
    <section id="contact" className="py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="overflow-hidden rounded-2xl bg-secondary-100/60 ring-1 ring-background-200">
          <div className="grid grid-cols-1 lg:grid-cols-2">
            <div className="flex flex-col justify-center p-6 md:p-10">
              <span className="text-sm font-bold uppercase tracking-widest text-secondary-700">
                联系我们
              </span>
              <h2 className="mt-2 font-heading text-3xl text-foreground-950 md:text-4xl">
                有好作品想分享？聊聊吧
              </h2>
              <p className="mt-3 text-foreground-700">
                无论是投稿推荐、意见反馈，还是想一起完善治愈系漫画清单，
                欢迎给我们留言，编辑部会认真看每一封信。
              </p>
              <div className="mt-6 space-y-3">
                {contactChannels.map((ch) => (
                  <div
                    key={ch.label}
                    className="flex items-center gap-3 rounded-xl bg-background-50 p-4 ring-1 ring-background-200"
                  >
                    <span className="flex h-10 w-10 items-center justify-center rounded-full bg-secondary-500 text-background-50">
                      <i className={`${ch.icon} text-lg`}></i>
                    </span>
                    <div>
                      <div className="text-sm font-bold text-foreground-950">
                        {ch.label}
                      </div>
                      <div className="text-sm text-foreground-600">
                        {ch.value}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <form
              data-readdy-form
              onSubmit={handleSubmit}
              className="flex flex-col gap-4 bg-background-50 p-6 md:p-10"
            >
              <div className="flex flex-col gap-4 sm:flex-row">
                <div className="flex-1">
                  <label htmlFor="name" className="mb-1.5 block text-sm font-bold text-foreground-800">
                    称呼
                  </label>
                  <input
                    id="name"
                    name="name"
                    type="text"
                    required
                    autoComplete="name"
                    placeholder="怎么称呼你"
                    className="w-full rounded-md border border-background-200 bg-background-50 px-4 py-2.5 text-sm text-foreground-900 outline-none transition-colors focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
                  />
                </div>
                <div className="flex-1">
                  <label htmlFor="email" className="mb-1.5 block text-sm font-bold text-foreground-800">
                    邮箱
                  </label>
                  <input
                    id="email"
                    name="email"
                    type="email"
                    required
                    autoComplete="email"
                    placeholder="you@example.com"
                    className="w-full rounded-md border border-background-200 bg-background-50 px-4 py-2.5 text-sm text-foreground-900 outline-none transition-colors focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
                  />
                </div>
              </div>

              <div>
                <label htmlFor="message" className="mb-1.5 block text-sm font-bold text-foreground-800">
                  留言
                </label>
                <textarea
                  id="message"
                  name="message"
                  required
                  maxLength={500}
                  rows={5}
                  placeholder="想推荐的作品、想说的话，都写在这里吧"
                  className="w-full resize-none rounded-md border border-background-200 bg-background-50 px-4 py-2.5 text-sm text-foreground-900 outline-none transition-colors focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
                ></textarea>
                <div className="mt-1 text-right text-xs text-foreground-400">
                  500 字以内
                </div>
              </div>

              <input
                name="website_alt"
                type="text"
                autoComplete="off"
                tabIndex={-1}
                aria-hidden="true"
                readOnly
                className="hp-field"
              />

              <button
                type="submit"
                disabled={status === "loading"}
                className="mt-1 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600 disabled:opacity-60"
              >
                {status === "loading" ? "发送中…" : "发送留言"}
              </button>

              {status === "success" && (
                <p className="rounded-lg bg-primary-100 px-4 py-3 text-sm font-medium text-primary-800">
                  谢谢你！留言已收到，我们会尽快回复。
                </p>
              )}
              {status === "error" && (
                <p className="rounded-lg bg-accent-100 px-4 py-3 text-sm font-medium text-accent-900">
                  {message || "提交失败，请稍后再试。"}
                </p>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}